module.exports = __webpack_public_path__ + "img/element-icons-30-x-30-ic-detail-download.114c0e42.svg";